import React from 'react';
import { Snackbar, Alert, Slide } from '@mui/material';
import { useApp } from '../../context/AppContext';

const SlideTransition = (props) => {
  return <Slide {...props} direction="up" />;
};

const NotificationSystem = () => {
  const { notifications, dispatch, ActionTypes } = useApp();

  const handleClose = (notificationId) => {
    dispatch({ type: ActionTypes.REMOVE_NOTIFICATION, payload: notificationId });
  };

  return (
    <>
      {notifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open={true}
          autoHideDuration={5000}
          onClose={() => handleClose(notification.id)}
          TransitionComponent={SlideTransition}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            onClose={() => handleClose(notification.id)}
            severity={notification.type}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default NotificationSystem;
